import { createContext, useContext } from 'react';

export interface EditCandidate {
  namespace: string;
  key: string;
  currentValue: string;
}

export interface EditTarget {
  candidates: EditCandidate[];
  position?: { x: number; y: number };
}

export interface EditModeContextType {
  isEditMode: boolean;
  setEditMode: (enabled: boolean) => void;
  canEdit: boolean;
  editTarget: EditTarget | null;
  setEditTarget: (target: EditTarget | null) => void;
  isGuestView: boolean;
  setGuestView: (enabled: boolean) => void;
}

export const EditModeContext = createContext<EditModeContextType | undefined>(undefined);

export function useEditMode(): EditModeContextType {
  const context = useContext(EditModeContext);
  if (context === undefined) {
    throw new Error('useEditMode must be used within EditModeProvider');
  }
  return context;
}
